<template>
  <div>
    <date-picker
      v-if="!hideStartsAt && !isSecondary"
      label="Starting date"
      v-model="startsAt"
      color="primary"
      :persistent-hint="!qualification.startsAt"
      :theme="themes.candidate.light"
      :rules="rules.startsAt"
      :max="qualification.endsAt"
      hint="Qualification or programme start date"
      append-icon="mdi-calendar-today"
      placeholder=""
      type="month"
      :show-day="false"
      required
      @input="updateDates"
    />

    <date-picker
      v-if="!hideEndsAt"
      label="Completion date"
      v-model="endsAt"
      :color="themes.candidate.light.input"
      :persistent-hint="!qualification.endsAt"
      :theme="themes.candidate.light"
      :rules="rules.endsAt"
      :min="qualification.startsAt"
      hint="Qualification or programme completion date"
      append-icon="mdi-calendar-today"
      placeholder=""
      type="month"
      :show-day="false"
      required
      @input="updateDates"
    />

    <date-picker
      v-if="requestGraduationDate || isProfessional"
      label="Accreditation date"
      v-model="accreditedAt"
      :color="themes.candidate.light.input"
      :persistent-hint="!qualification.accreditedAt"
      :theme="themes.candidate.light"
      :min="qualification.endsAt"
      hint="When proof of certification will be / was issued"
      append-icon="mdi-calendar-today"
      placeholder=""
      @input="updateDates"
    />
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  created() {
    if (this.qualification && this.qualification.startsAt) {
      this.startsAt = this.$date(new Date(this.qualification.startsAt), 'yyyy-MM-dd')
    }
    if (this.qualification && this.qualification.endsAt) {
      this.endsAt = this.$date(new Date(this.qualification.endsAt), 'yyyy-MM-dd')
    }
    if (this.qualification && this.qualification.accreditedAt) {
      this.accreditedAt = this.$date(new Date(this.qualification.accreditedAt), 'yyyy-MM-dd')
    }
  },

  model: { prop: 'qualification' },

  props: {
    qualification: { type: Object, required: true },
    requestGraduationDate: { type: Boolean, default: true },
    hideStartsAt: { type: Boolean, default: false },
    hideEndsAt: { type: Boolean, default: false },
  },

  data() {
    return {
      startsAt: null,
      endsAt: null,
      accreditedAt: null,
      rules: {
        startsAt: [
          v => !!v || 'You must specify a starting date',
          v =>
            !this.qualification.endsAt ||
            new Date(this.qualification.startsAt) <= new Date(this.qualification.endsAt) ||
            'must be before completion date',
        ],
        endsAt: [
          v => !!v || 'You must provide a completion date. Use an estimated date if needed',
          v => new Date(this.qualification.endsAt) >= new Date(this.qualification.startsAt) || 'must be after starting date',
        ],
      },
    }
  },

  computed: {
    isProfessional() {
      return (
        _.get(this, 'qualification.qualification.qualificationCategory.name') ===
          'Professional Qualification' ||
        _.get(this, 'qualification.qualification.qualificationType.qualificationCategory.name') ===
          'Professional Qualification'
      )
    },

    isSecondary() {
      return (
        _.get(this, 'qualification.qualification.qualificationCategory.name') ===
          'Secondary Education' ||
        _.get(this, 'qualification.qualification.qualificationType.qualificationCategory.name') ===
          'Secondary Education'
      )
    },
  },

  methods: {
    updateStartsAt() {
      if (this.accreditedAt && !this.startsAt) {
        this.startsAt = this.$date(new Date(this.accreditedAt), 'yyyy-MM-dd')
      }
      if (!this.startsAt) {
        const date = new Date(this.endsAt)
        this.startsAt = this.$date(new Date(date.setMonth(date.getMonth() - 11)), 'yyyy-MM-dd')
      } else {
        this.startsAt = this.$date(new Date(this.startsAt), 'yyyy-MM-dd')
      }
    },

    updateEndsAt() {
      if (this.accreditedAt && !this.endsAt) {
        this.endsAt = this.$date(new Date(this.accreditedAt), 'yyyy-MM-dd')
      }
      // Stop populating ends at to force users to specify it
      // if (!this.endsAt) {
      //   const date = new Date(this.startsAt)
      //   const endsAt = new Date(date.getFullYear(), date.getMonth()+12, date.getDate()-1);
      //   this.endsAt = this.$date(endsAt)
      // }
      if (this.endsAt) {
        this.endsAt = this.$date(new Date(this.endsAt), 'yyyy-MM-dd')
      }
    },

    updateAccreditedAt() {
      if (!this.accreditedAt || new Date(this.endsAt) > new Date(this.accreditedAt)) {
        this.accreditedAt = this.$date(new Date(this.endsAt), 'yyyy-MM-dd')
      }
    },

    updateDates() {
      this.updateStartsAt()
      this.updateEndsAt()
      if (this.requestGraduationDate || this.isProfessional) this.updateAccreditedAt()

      this.$emit('input', {
        ...this.qualification,
        ...{
          startsAt: this.startsAt,
          endsAt: this.endsAt,
          accreditedAt: this.accreditedAt,
        },
      })
    },
  },
}
</script>
